export const NEW_PURCHASE_COMPLETED = "NEW_PURCHASE_COMPLETED";
export const BUY_AGAIN_COMPLETED = "BUY_AGAIN_COMPLETED";
export const CHECK_STATUS_COMPLETED = "CHECK_STATUS_COMPLETED";